import { Button, Modal } from "flowbite-react";
import { HiDocumentDuplicate } from "react-icons/hi";
import { Event } from "../../Models/Event";

type CopyConferenceModalProps = {
  show: boolean;
  conference: Event | null;
  isCopying: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function CopyConferenceModal({
  show,
  conference,
  isCopying,
  onClose,
  onConfirm,
}: CopyConferenceModalProps) {
  if (!conference) return null;

  return (
    <Modal show={show} size="md" onClose={onClose} popup dismissible>
      <Modal.Header className="border-b border-gray-200 pb-4">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
            <HiDocumentDuplicate className="h-6 w-6 text-blue-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Copy Conference as Template
            </h3>
            <p className="text-sm text-gray-500">
              Create a new conference from this one
            </p>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="pt-6">
        <div className="space-y-4">
          <p className="text-gray-700">
            Copy <span className="font-semibold text-gray-900">{conference.name}</span>{" "}
            with all of its content to use as a starting point for a new conference?
          </p>

          <div className="rounded-lg bg-gray-50 p-4">
            <p className="mb-2 text-sm font-medium text-gray-700">What will be copied:</p>
            <ul className="list-inside list-disc space-y-1 text-sm text-gray-600">
              <li>Conference and all sub-events</li>
              <li>Pages and forms</li>
              <li>Event structure and settings</li>
            </ul>
          </div>

          <div className="rounded-lg border border-amber-200 bg-amber-50 p-3">
            <p className="text-sm text-amber-800">
              <span className="font-medium">Note:</span> Participants will not be copied.
              You will need to update dates and times for the new conference.
            </p>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-t border-gray-200 pt-4">
        <Button color="gray" onClick={onClose} disabled={isCopying}>
          Cancel
        </Button>
        <Button
          className="bg-blue-600 hover:bg-blue-700"
          onClick={onConfirm}
          disabled={isCopying}
        >
          {isCopying ? "Copying..." : "Copy Conference"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
